import moduleRegistry from '../module-registry/module-registry';

const config = {
    selectors: {
        root: '.accordion-modul',
        accordionItem: '.accordion-modul__item',
        accordionHeadline: '.accordion-modul__header',
        accordionContent: '.accordion-modul__collapse',
        accordionContentShow: '.accordion-modul__collapse--show',
        accordionIcon: '.accordion-modul__header-icon'
    },
    classNames: {
        accordionContentShow: 'accordion-modul__collapse--show',
        accordionIconOpen: 'accordion-modul__header-icon--open',
        accordionHeadlineActive: 'accordion-modul__header--active',
    },
};

class AccordionModul {
    constructor($rootElement, options) {
        this._$rootElement = $rootElement;
        this._options = options;
        this._elements = null;
        this._isHidden = true;
    }

    init() {
        this._elements = this._getDomElements();
      
        const smartedit = $('body').data('smartedit');

        if(smartedit === true || smartedit === 'true') {
            this._elements.$accordionContent.addClass(config.classNames.accordionContentShow);
            this._elements.$accordionContent.css('height', `${this._elements.$accordionContent[0].scrollHeight}px `)
            this._elements.$accordionIcon.addClass(config.classNames.accordionIconOpen)
        }
        this._accordion();
    }

    _getDomElements() {
        return {
            $accordionHeadline: this._$rootElement.find(config.selectors.accordionHeadline),
            $accordionItem: this._$rootElement.find(config.selectors.accordionItem),
            $accordionContentShow: this._$rootElement.find(config.selectors.accordionContentShow),
            $accordionContent: this._$rootElement.find(config.selectors.accordionContent),
            $accordionIcon: this._$rootElement.find(config.selectors.accordionIcon),
        };
    }
    _hideAll() {
        this._elements.$accordionIcon.removeClass(config.classNames.accordionIconOpen)
        this._elements.$accordionContent.removeClass(config.classNames.accordionContentShow)
        this._elements.$accordionContent.height(0);
        this._elements.$accordionHeadline.removeClass(config.classNames.accordionHeadlineActive)
    }

    _accordion() {
      const _this = this;

        this._$rootElement.find(config.selectors.accordionHeadline).on('click', (e) => {
            
            const closestContent =  $(e.currentTarget).siblings(config.selectors.accordionContent);
            const closestIcon = $(e.currentTarget).children(config.selectors.accordionIcon);
            if(!closestContent.hasClass(config.classNames.accordionContentShow)) {
             
                _this._hideAll();
                $(e.currentTarget).addClass(config.classNames.accordionHeadlineActive)
                closestContent.addClass(config.classNames.accordionContentShow);
                closestContent.css('height', `${closestContent[0].scrollHeight}px `)
       
                closestIcon.addClass(config.classNames.accordionIconOpen)

            }else {
                $(e.currentTarget).removeClass(config.classNames.accordionHeadlineActive)
                closestContent.removeClass(config.classNames.accordionContentShow);
                closestContent.css('height', `0`)
                closestIcon.removeClass(config.classNames.accordionIconOpen)
            }
            
        })

        
    }
}

moduleRegistry.registerModule('AccordionModul', AccordionModul);
moduleRegistry.autoApplyModule('AccordionModul', config.selectors.root);
